/**
 * 首页模块配置
 * 统一管理首页模块的路由、菜单、权限配置
 * @author AI Assistant
 * @date 2024-12-19
 */

import type { ModuleConfig } from '@/types/module-config'

/**
 * 首页模块配置
 */
const moduleConfig: ModuleConfig = {
  id: 'dashboard',
  name: '首页',
  description: '系统首页模块，提供系统概览和快捷入口',
  version: '1.0.0',
  enabled: true,

  // 路由配置
  routes: [
    {
      path: '/home',
      name: 'Dashboard',
      component: '@/modules/dashboard/pages/index.vue',
      meta: {
        title: '首页',
        icon: 'House',
        permissions: ['dashboard:view'],
        keepAlive: true,
        affix: true, // 设置为固定标签页，常驻且不可关闭
        order: 1
      }
    }
  ],

  // 权限配置
  permissions: [
    {
      code: 'dashboard:view',
      name: '查看首页',
      type: 'menu',
      description: '查看系统首页',
      apiPath: '/dashboard'
    },
    {
      code: 'dashboard:refresh',
      name: '刷新数据',
      type: 'operation',
      description: '刷新首页数据',
      apiPath: '/dashboard/refresh'
    },
    {
      code: 'dashboard:export',
      name: '导出数据',
      type: 'operation',
      description: '导出首页统计数据',
      apiPath: '/dashboard/export'
    },
    {
      code: 'dashboard:statistics',
      name: '查看统计数据',
      type: 'operation',
      description: '查看首页统计数据',
      apiPath: '/dashboard/statistics'
    },
    {
      code: 'dashboard:charts',
      name: '查看图表数据',
      type: 'operation',
      description: '查看首页图表数据',
      apiPath: '/dashboard/charts'
    }
  ],

  // 导航配置 - 首页作为独立的一级菜单
  navigation: {
    name: 'dashboard',
    title: '首页',
    icon: 'House',
    order: 1,
    permissions: ['dashboard:view'],
    items: [
      {
        id: 'dashboard',
        title: '首页',
        path: '/home',
        icon: 'House',
        order: 1,
        permissions: ['dashboard:view'],
        module: 'dashboard',
        component: '@/modules/dashboard/pages/index.vue',
        affix: true, // 设置为固定标签页
        meta: {
          keepAlive: true,
          affix: true
        }
      }
    ]
  }
}

export default moduleConfig
